import { render } from "./CompareEoL.vue?vue&type=template&id=5712f4d4&scoped=true"
import script from "./CompareEoL.vue?vue&type=script&lang=js"
export * from "./CompareEoL.vue?vue&type=script&lang=js"

import "./CompareEoL.vue?vue&type=style&index=0&id=5712f4d4&lang=scss&scoped=true"

import exportComponent from "C:\\Devprojects\\cedaci-compass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5712f4d4"]])

export default __exports__